export const nav = {
    permissao: "lpbuilder.deploys:visualizar",
    section: "LPBuilder",
    title: "Publicacoes",
    icon: "rocket_launch",
    route: "/publicacoes",
    sequence: 6,
};
export default [
    {
        path: "/publicacoes",
        name: "lpbuilder-publicacoes",
        component: () => import("./pages/PublicacoesPage.vue"),
        meta: { requiresAuth: true, permissao: "lpbuilder.deploys:visualizar" },
    },
];
